const MIN_STAY_ERROR = 1
const MAX_STAY_ERROR = 2
const NO_CHECK_IN_ERROR = 3
const NO_CHECK_OUT_ERROR = 4
const MIN_ADVANCE_RESERVATION_ERROR = 5
const MAX_ADVANCE_RESERVATION_ERROR = 6
const MIN_STAY_ARRIVAL_ERROR = 7
const MAX_STAY_ARRIVAL_ERROR = 8
const CLOSED_ERROR = 9

const HIDE_RATE_ERRORS = [
  CLOSED_ERROR,
  NO_CHECK_IN_ERROR,
  NO_CHECK_OUT_ERROR,
  MIN_ADVANCE_RESERVATION_ERROR,
  MAX_ADVANCE_RESERVATION_ERROR,
  MIN_STAY_ARRIVAL_ERROR,
  MAX_STAY_ARRIVAL_ERROR
]

const shouldHideRate = ratePlan => ratePlan?.restrictionErrors?.some(err => HIDE_RATE_ERRORS.includes(err))

export {
  MIN_STAY_ERROR,
  MAX_STAY_ERROR,
  NO_CHECK_IN_ERROR,
  NO_CHECK_OUT_ERROR,
  MIN_ADVANCE_RESERVATION_ERROR,
  MAX_ADVANCE_RESERVATION_ERROR,
  MIN_STAY_ARRIVAL_ERROR,
  MAX_STAY_ARRIVAL_ERROR,
  CLOSED_ERROR,
  shouldHideRate
}
